import { BlurEvent, ChangeEvent, Checkbox, FocusEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutMobileCommExAppControlTrailerTracking } from "./autogen/AutogenLayoutMobileCommExAppControlTrailerTracking";
import { MobileCommFieldValidator } from "./MobileCommFieldValidator";
import { MobileCommExAppControlHelper } from "./MobileCommExAppControlBase";

export class MobileCommExAppControlTrailerTracking extends AutogenLayoutMobileCommExAppControlTrailerTracking {

    private static readonly FIELD_TEXTBOX_IDS = [
        "textboxTrailerEmptyField",
        "textboxOdometerField",
        "textboxBatteryStatusField",
        "textboxSetpointField",
        "textboxReturnAirField",
        "textboxReeferProfileField",
        "textboxFuelLevelTrailerField",
        "textboxFuelPercentField"
    ];

    /**
     * Validates all field index textboxes to ensure values are within valid range.
     * @returns true if all validations pass, false otherwise
     */
    public validateAllFieldIndices(): boolean {
        return MobileCommFieldValidator.validateAllFieldIndices(
            this,
            MobileCommExAppControlTrailerTracking.FIELD_TEXTBOX_IDS,
            () => MobileCommFieldValidator.getMaxRowIndex(this.owner)
        );
    }

    /**
     * Event handler for textbox blur events.
     * Validates the field index value and displays inline warning if invalid.
     * @param event - the blur event
     */
    textboxFieldValidateOnBlur(event: BlurEvent): void {
        const textbox = event.target as Textbox;
        if (!event.changedWhileFocused) {
            return;
        }

        MobileCommFieldValidator.validateFieldOnBlur(
            textbox,
            this.owner.textboxToCheckboxMap.get(textbox.id),
            this.owner.findTextboxGroup(textbox.id),
            () => MobileCommFieldValidator.getMaxRowIndex(this.owner)
        );
    }

    /**
     * Event handler for component focus events.
     * Highlights the corresponding row in the form builder when a field textbox receives focus.
     * @param event - the focus event
     */
    componentOnFocus(event: FocusEvent): void {
        this.highlightFormField(event);
    }

    /**
     * Event handler for textbox change events.
     * Highlights the corresponding row in the form builder when a field textbox changes.
     * @param event - the change event
     */
    textboxOnChange(event: ChangeEvent): void {
        this.highlightFormField(event);
    }

    private highlightFormField(event: FocusEvent | ChangeEvent): void {
        MobileCommExAppControlHelper.componentOnFocus(event, this, MobileCommExAppControlTrailerTracking.FIELD_TEXTBOX_IDS);
    }
}
